/** HelpTab — reuses the full HelpContent panel rendered in the in-app drawer. */
import { HelpContent } from "@/components/r3d/HelpModal";

export default function HelpTab() {
  return <HelpContent />;
}
